import React from 'react'
import Navbar from '../componets/Navbar/Navbar'
import Footer from '../componets/Footer/Footer'
import GoTop from '../componets/GoTop/GoTop'
import Login from '../componets/SingUp/Login'

const Service = () => {
    return (
        <>
            <Navbar />
            <Login />
            <Footer />
            <GoTop />
        </>
    )
}

export default Service